/*
 * Enova - Panel del megamenú (pestañas + carrusel de productos)
 * =============================================================
 * Web Component <enova-mega-menu> renderizado por snippets/header-product-panel.liquid.
 *  - Clic en una pestaña: muestra su panel y oculta los demás.
 *  - Flechas: desplazan el carrusel de productos del panel activo.
 */

(function () {
  if (customElements.get('enova-mega-menu')) return;

  const selectors = {
    tab: '[data-mega-tab]',
    panel: '[data-mega-panel]',
    track: '[data-mega-track]',
    prev: '[data-mega-prev]',
    next: '[data-mega-next]',
  };

  const classes = {
    active: 'is-active',
    hidden: 'is-hidden',
  };

  customElements.define(
    'enova-mega-menu',

    class EnovaMegaMenu extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll(selectors.tab));
        this.panels = Array.from(this.querySelectorAll(selectors.panel));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.getAttribute('data-mega-tab')));
        });

        this.panels.forEach((panel) => this.initCarousel(panel));
      }

      disconnectedCallback() {
        this.observers?.forEach((observer) => observer.disconnect());
      }

      activate(id) {
        this.tabs.forEach((tab) => {
          const isActive = tab.getAttribute('data-mega-tab') === id;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.closest('.enova-mega__tab')?.classList.toggle(classes.active, isActive);
        });

        this.panels.forEach((panel) => {
          const isActive = panel.getAttribute('data-mega-panel') === id;
          panel.classList.toggle(classes.active, isActive);
          if (isActive) this.updateArrows(panel);
        });
      }

      initCarousel(panel) {
        const track = panel.querySelector(selectors.track);
        const prev = panel.querySelector(selectors.prev);
        const next = panel.querySelector(selectors.next);
        if (!track) return;

        prev?.addEventListener('click', () => this.scrollTrack(track, -1));
        next?.addEventListener('click', () => this.scrollTrack(track, 1));
        track.addEventListener('scroll', () => this.updateArrows(panel), {passive: true});

        // El panel mide 0 mientras el megamenú está cerrado: recalcula al abrirse.
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => this.updateArrows(panel));
          observer.observe(track);
          this.observers = this.observers || [];
          this.observers.push(observer);
        }

        this.updateArrows(panel);
      }

      scrollTrack(track, direction) {
        track.scrollBy({left: direction * track.clientWidth * 0.8, behavior: 'smooth'});
      }

      updateArrows(panel) {
        const track = panel.querySelector(selectors.track);
        const prev = panel.querySelector(selectors.prev);
        const next = panel.querySelector(selectors.next);
        if (!track) return;

        const maxScroll = track.scrollWidth - track.clientWidth;
        prev?.classList.toggle(classes.hidden, track.scrollLeft <= 2);
        next?.classList.toggle(classes.hidden, maxScroll <= 2 || track.scrollLeft >= maxScroll - 2);
      }
    }
  );
})();